import React from 'react';
import styled from 'styled-components';
import { Flex } from '../shared/Flex';
import { useAlertColors } from './useAlertColors';
import { fontSize, fontWeight } from '../../style/tokens';

const Wrapper = styled(Flex)<{ bg: string; border: string }>`
  height: auto;
  min-width: 50%;
  max-width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border: 2px solid ${({ border }) => border};
  border-radius: 8px;
  background: ${({ bg }) => bg};
  box-sizing: border-box;
`;

const Message = styled.div<{ color: string; secondary?: boolean }>`
  padding: 5px;
  font-size: ${({ secondary }) => secondary ? fontSize.md : fontSize.lg};
  font-weight: ${({ secondary }) => secondary ? fontWeight.normal : fontWeight.normal};
  font-family: inherit;
  color: ${({ color }) => color};
  text-align: center;
  opacity: ${({ secondary }) => secondary ? 0.85 : 1};
`;

interface InfoAlertProps {
  message?: string;
  solution?: string;
}

const InfoAlert = ({ message, solution }: InfoAlertProps) => {
  const { bg, border, textColor } = useAlertColors();

  if (!message) {
    return null;
  }

  return (
    <Wrapper bg={bg} border={border}>
      <Message color={textColor}>{message}</Message>
      {solution && <Message color={textColor} secondary>{solution}</Message>}
    </Wrapper>
  );
};
export default InfoAlert;
